//* 组件库
import type { UiTableOption2 } from "various-ui";
import { animations } from "various-ui";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    //* 配置
    const option = <UiTableOption2[]>[
        { name: i18n.t("Residues", 1), key: "name", align: "center" },
        { name: i18n.t("Sequence"), key: "sequence", align: "singularity" },
        { name: "PMID", key: "id", align: "singularity" },
        { name: i18n.t("Species"), key: "species", align: "center" },
        { name: i18n.t("Tissue"), key: "tissue", align: "center" },
        { name: i18n.t("Cells"), key: "cell", align: "center" },
    ];

    //* 动画
    const ons = {
        animation: animations.selector(true),
    };

    return { ons, option };
};
